/**
 * List
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';
import CommentTextCount from './CommentTextCount';
import User from '../../User';
import GameInfo from '../../GameInfo';
import L10N from "../../Lang";

class CommentWrite {

	public onWrite: any;

	private $parent: any;

	private _id: string;

	private id: string;

	private isSubmit: boolean = false;

	private articleId: string;

	private formId: string;

	private commentTextCount: CommentTextCount;

	constructor( $parent: any, articleId: string ) {
		this.$parent = $parent;
		this._id = this.$parent.attr( 'id' );
		this.articleId = articleId || ( window as any ).articleId || Util.getParams().articleId;
		this.id = 'contentWrite';
		this.isSubmit = false;
		this.onWrite = new Util.Observer();

		this.formId = `comment-form-${this.id}`;
		this.commentTextCount = new CommentTextCount( `#${this._id} .${this.formId}` );
		// if( Config.isBnsApp ) this.enterSubmit();
	}

	public setPlaceHolder( placeHolder: string ) {
		jQuery( `#${this._id} .${this.id}` ).attr( 'placeholder', placeHolder );
	}

	public formCheckAndSubmit() {
		const _$this: any = jQuery( `#${this._id} .${this.id}` );
		let _val = _$this.val();

		_val = Util.escapeTag( _val );

		if ( _val.length === 0 || !jQuery.trim( _val ) ) {
			Config.alert( Config.L10N.alert_empty_comment );
			return;
		}

		if ( _val.length > Config.commentTextMaxCount ) {
			Config.alert( Config.L10N.comment_placeholder_login_max( Config.commentTextMaxCount ) );
			return;
		}

		_val = _val.replace(/\n/g, '<br />');

		const _data = {
			contents: _val,
		};

		// if( Config.isBnsApp ) {
		// 	_data.articleId = this.articleId;
		// 	_data.boardName = Util.getParams().boardAlias;
		// }

		this.submit( _data );
	}

	public appBanned() {
		const url = Config.app.banned( Util.net( '.' ) );
		const _post = Util.get( url, 'GET' );
		_post.then( ( data: any ) => {
			if ( data.is_banned === true ) {
				Config.alert( Config.L10N.alert_banned );
				return;
			}

			this.formCheckAndSubmit();

		}, ( err: any ) => {
			Config.alert( err.message );
		});
	}

	public appLevelBanned() {
		const _lv = Util.getParams().level;
		if ( _lv && _lv < 9 ) {
			Config.alert( Config.L10N.alert_level_check );
			jQuery( `#${this._id} .${this.id}` ).blur();
			return true;
		}
		return false;
	}

	public setUI() {
        const win = window as any;
        const _placeHolder = ( !Config.isLogin() ) ?
            Config.L10N.comment_placeholder_logout :
            ( Config.isCommentUpload && Config.isCommentEmoticon ) ?
                Config.L10N.comment_placeholder_emoticon :
                ( Config.isCommentUpload ) ?
                    Config.L10N.comment_placeholder_image :
					Config.L10N.comment_placeholder_login_max( Config.commentTextMaxCount );

        const write = Template.commentWrite( this.id, _placeHolder );

        jQuery( 'body' ).on( 'click', `#${this._id} .btn-${this.id}`, ( evt ) => {
			evt.preventDefault();

			// check banned
			if ( Config.isBnsApp ) {
				this.appBanned();
			} else {
				this.formCheckAndSubmit();
			}
		});
        jQuery( 'body' ).on( 'focus', `#${this._id} .${this.id}` , ( evt ) => {
			evt.preventDefault();

			if ( !Config.isLogin() ) {
				jQuery( `#${this._id} .${this.id}` ).blur();

				if ( win.GNBLogin ) {
                    win.GNBLogin();
                } else {
                    Config.alert( Config.L10N.alert_login );
				}

				return;
			}

			if ( User.isCheckNotExistGameAccount() && GameInfo.isLogined() ) {
				Config.alert( Config.L10N.alert_not_exist_gameaccount );
				jQuery( `#${this._id} .${this.id}` ).blur();
				return;
			}

			// Lv10
			if ( Config.isBnsApp && this.appLevelBanned() ) {
				return;
			}

			jQuery( `#${this._id} .comment-form-${this.id}` ).addClass( 'is-focus' );
		});
        jQuery( 'body' ).on( 'click' , ( evt ) => {
			const $thisForm = jQuery( `#${this._id} .comment-form-${this.id}` );

			if (!$thisForm.is( evt.target ) && $thisForm.has( evt.target ).length === 0 ) {
				$thisForm.removeClass( 'is-focus' );
			}
		});

		return write;
	}

	public getNode() {
		return jQuery( `#${this._id} .${this.id}` );
	}

	public clear() {
		jQuery( `#${this._id} .${this.id}` ).val( '' );
		this.commentTextCount.reset();
	}

	// type ['emoticon', 'image']
	public submit( data: any, type = 'text' ) {
		if ( this.isSubmit ) {
			return;
		}

		this.isSubmit = true;

		const _method = 'POST';

		// developer Emoticon
		const commentAPI = Config.commentWrite({
			board: Config.board,
			articleId: this.articleId,
		});

		const win = window as any;

		if ( win._commentInfo && win._commentInfo.emoticonUrl && win._commentInfo.isOperator ) {
			data.emoticonUrl = win._commentInfo.emoticonUrl;
		}

		const _post = Util.get( commentAPI, _method, data );
		_post.then( ( commentData: any ) => {
			commentData = Util.convertCamelCase( commentData );
			( !Config.isLogin() ) ?
				this.setPlaceHolder( Config.L10N.comment_placeholder_logout ) :
				this.setPlaceHolder( ( Config.isCommentUpload && Config.isCommentEmoticon ) ?
					Config.L10N.comment_placeholder_emoticon : ( Config.isCommentUpload ) ?
                        Config.L10N.comment_placeholder_image : Config.L10N.comment_placeholder_login_max( Config.commentTextMaxCount ) );

			if ( type ) {
				commentData.commentResourceType = type;
			}

			this.onWrite.emit( commentData );

			setTimeout( () => {
				this.isSubmit = false;
			});

		}, ( commentData: any ) => {
			commentData = Util.convertCamelCase( commentData );
			setTimeout( () => {
				this.isSubmit = false;
			});

			Config.apiError( commentData );
		});
	}

	// @TODO
	public enterSubmit() {
		jQuery( 'body' ).on( 'keypress', `#${this._id} .${this.id}` , ( evt: any ) => {
			const key = evt.keyCode;
			if ( key === 13 ) {
				evt.preventDefault();
				this.formCheckAndSubmit();
			}
		});
	}
}

export default CommentWrite;
